/* eslint-disable */
// Theses classes should correspond to the softmax output of your model.

export const MODEL_CLASSES = {
  0: 'Actinic Keratoses - Danger',
  1: 'Basal Cell Carcinoma - Danger',
  2: 'Benign Keratosis like Lesion - Harmless',
  3: 'Dermatofibroma - Harmless',
  4: 'Melanocytic Nevi - Caution',
  5: 'Vascular Lesion - Harmless',
  6: 'Melanoma - Danger'
};
